export const socketIdCookieKey = 'frontdeskaisocketid'
export const cookieExpiry = 604800
export const baseWSURL = 'io.truelark.com'
export const baseRESTURL = 'ops.truelark.com'
export const wsURL = `wss://${baseWSURL}/webchat`
export const apiURL = `https://${baseRESTURL}`
export const trueLarkLink = 'https://truelark.com'
